import { render, staticRenderFns } from "./FundIndustryDetail.vue?vue&type=template&id=0ac35d28&scoped=true"
import script from "./FundIndustryDetail.vue?vue&type=script&lang=js"
export * from "./FundIndustryDetail.vue?vue&type=script&lang=js"
import style0 from "./FundIndustryDetail.vue?vue&type=style&index=0&id=0ac35d28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac35d28",
  null
  
)

export default component.exports